export enum CommentsListType {
  FilteredComments = 'FilteredComments',
  NoneRelevantComments = 'NoneRelevantComments',
}
